import React, { useState, useEffect } from 'react';
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { VisuallyHidden } from "@radix-ui/react-visually-hidden";
import { Button } from "@/components/ui/button";
import { Brain, Building, LayoutDashboard, ArrowRight } from 'lucide-react';

const OnboardingDialog = () => {
  const [open, setOpen] = useState(false);
  const [step, setStep] = useState(0);

  useEffect(() => {
    const hasSeenOnboarding = localStorage.getItem('livcom_onboarding_seen');
    if (!hasSeenOnboarding) {
      setOpen(true);
    }
  }, []);

  const handleNext = () => {
    if (step < 2) {
      setStep(step + 1);
    } else {
      handleClose();
    }
  };

  const handleClose = () => {
    localStorage.setItem('livcom_onboarding_seen', 'true');
    setOpen(false);
  };

  const slides = [
    {
      icon: <LayoutDashboard className="h-16 w-16 text-primary mb-6" />,
      title: "Bienvenido a LivCom",
      description: "Tu nuevo centro de comando. Centraliza la operación de todos tus conjuntos residenciales en una sola plataforma inteligente."
    },
    {
      icon: <Building className="h-16 w-16 text-accent mb-6" />,
      title: "Contexto Global",
      description: "Usa el selector en la barra superior para cambiar de edificio. Toda la información se filtrará automáticamente según tu selección."
    },
    {
      icon: <Brain className="h-16 w-16 text-secondary mb-6" />,
      title: "Tu Copiloto IA",
      description: "No pierdas tiempo buscando. LivCom analiza tus datos y te entrega un resumen diario con lo que realmente requiere tu atención."
    }
  ];

  return (
    <Dialog open={open} onOpenChange={handleClose}>
      <DialogContent className="sm:max-w-[450px] p-0 overflow-hidden bg-white border-0 shadow-2xl">
        <VisuallyHidden>
          <DialogTitle>{slides[step]?.title || 'LivCom'}</DialogTitle>
          <DialogDescription>{slides[step]?.description || 'Tutorial de bienvenida a LivCom'}</DialogDescription>
        </VisuallyHidden>
        <div className="flex flex-col items-center text-center p-10 min-h-[400px]">
          <div className="flex-1 flex flex-col items-center justify-center">
            {slides[step].icon}
            <h2 className="text-2xl font-heading font-bold text-primary mb-4">
              {slides[step].title}
            </h2>
            <p className="text-text-secondary leading-relaxed">
              {slides[step].description}
            </p>
          </div>
          
          <div className="w-full mt-8">
            <div className="flex justify-center gap-2 mb-6">
              {slides.map((_, i) => (
                <div 
                  key={i}
                  className={`h-2 rounded-full transition-all duration-300 ${i === step ? 'w-8 bg-primary' : 'w-2 bg-slate-200'}`}
                />
              ))}
            </div>
            
            <Button 
              onClick={handleNext}
              className="w-full bg-primary hover:bg-primary/90 text-white rounded-xl py-6 text-lg"
            >
              {step === 2 ? 'Comenzar' : 'Siguiente'}
              {step < 2 && <ArrowRight className="ml-2 h-5 w-5" />}
            </Button>
            
            {step < 2 && (
              <button 
                onClick={handleClose}
                className="mt-4 text-sm text-slate-400 hover:text-slate-600"
              >
                Omitir tutorial
              </button>
            )}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default OnboardingDialog;
